import PurchasesPageHeader from './PurchasesPageHeader'

export default PurchasesPageHeader
